// 注册弹窗组件

import React, { useState } from "react";
import { Button } from "@/components/ui";
import { Input } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/Dialog";
import { toast } from "sonner";
import { register } from "@/api/register";
import { useUserStore } from "@/store/UserStore";

interface RegisterProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenLogin: () => void;
  onRegisterSuccess?: () => void;
}

export const RegisterModal: React.FC<RegisterProps> = ({
  open,
  onOpenChange,
  onOpenLogin,
  onRegisterSuccess,
}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  const { login } = useUserStore(); 

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !password || !confirmPassword) {
      toast.error("请填写所有字段");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("两次输入的密码不一致");
      return;
    }

    setIsLoading(true);
    try {
      const response = await register({
        username: username,
        password: password,
      });
      
      if (response?.data?.token) {
        login(response.data.token);
      }
      
      if (onRegisterSuccess) {
        onRegisterSuccess();
      }
    } catch (error: any) {
      console.error("Registration error:", error);
      let errorMessage = "注册失败，请稍后重试";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      } else if (error.response?.status === 0) {
        errorMessage = "网络连接失败，请检查网络设置";
      }

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogDescription className="sr-only">请注册您的账号</DialogDescription>
        <DialogHeader className="mb-4">
          <DialogTitle className="text-2xl font-bold text-center">
            <DialogDescription className="text-sm text-center text-gray-500">
              请注册您的账号
            </DialogDescription>
            注册新账号
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleRegister} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="reg-username">用户名</label>
            <Input
              id="reg-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="请输入用户名"
              required
              autoComplete="new-username"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="reg-password">密码</label>
            <Input
              id="reg-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="请输入密码"
              required
              autoComplete="new-password"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="reg-confirm-password">确认密码</label>
            <Input
              id="reg-confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="请再次输入密码"
              required
              autoComplete="new-password"
            />
          </div>
          <Button type="submit" className="w-full mt-6" disabled={isLoading}>
            {isLoading ? "注册中..." : "注册"}
          </Button>
        </form>
        <DialogFooter className="mt-4">
          <Button
            type="button"
            variant="link"
            className="w-full"
            onClick={onOpenLogin}
          >
            已有账号？返回登录
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};